import {Component, Inject, inject, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DialogTextModel} from "../../../core/cms/models/dialog.text.model";
import {DialogRestService} from "../../../core/cms/services/dialog.rest.service";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule} from "@angular/material/dialog";

@Component({
  selector: 'app-normal',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule
  ],
  templateUrl: './normal.component.html',
  styleUrl: './normal.component.scss'
})
export class NormalComponent implements OnDestroy {
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  private dialogRestService = inject(DialogRestService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogTextModel,
              public dialogRef: MatDialogRef<NormalComponent>) {
  }

  onImageClick() {
    this.dialogRestService.subscribeToDialogOffer(this.data.id, this.data.idf).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((res) => {
      if (this.data.link != null && res.error_code === null) {
        window.open(this.data.link, this.data.target);
      }
      this.dialogRef.close();
    });
  }

  ngOnDestroy(): void {
    // This aborts all HTTP requests.
    this.ngUnsubscribe$.next();
    // This completes the subject properly.
    this.ngUnsubscribe$.complete();
  }
}
